// extracted by mini-css-extract-plugin
module.exports = {"text":"styles-skeleton_text__uxwVg","chevron":"styles-skeleton_chevron__SCKGy","skeleton-animation":"styles-skeleton_skeleton-animation__Y3vfm"};